'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _throughAgentFactory = require('./throughAgentFactory');

var _throughAgentFactory2 = _interopRequireDefault(_throughAgentFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createAgent(area, key) {
  return (0, _throughAgentFactory2.default)(area, key);
}

exports.default = createAgent;